// tslint:disable: max-line-length
// tslint:disable: jsx-alignment
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class Timeline extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon width="18" height="18" viewBox="0 0 18 18">
                <g id="Notifications-Flows-v7">
                    <g id="Asrt-Collab-Pro-v5.22" transform="translate(-1161.000000, -113.000000)">
                        <g id="toolbar-48" transform="translate(0.000000, 104.000000)">
                            <g id="Group-7-Copy-3" transform="translate(1143.000000, 5.000000)">
                                <g id="view-changes01" transform="translate(16.000000, 3.000000)">
                                    <g id="Group-6" transform="translate(2.250000, 1.500000)">
                                        <path d="M9.2,9.7L7.3,7.8l1.2-1.2l1.9,1.9L9.2,9.7z M4.4,14.5H2.5v-1.9l3.8-3.8l1.9,1.9L4.4,14.5z M12,8L9,5C8.7,4.7,8.3,4.7,8,5l-6.8,6.8C1.1,11.9,1,12.1,1,12.3v3C1,15.7,1.3,16,1.8,16h3c0.2,0,0.4-0.1,0.5-0.2L12,9 C12.3,8.7,12.3,8.3,12,8L12,8z" />
                                        <path d="M15,14.5l-1.7-0.2c2.4-2,3.3-5.3,2.2-8.4c-0.7-1.9-2.1-3.4-3.9-4.3C9.9,0.9,7.8,0.8,6,1.5 C3.6,2.3,1.8,4.3,1.2,6.8C1.1,7.2,1.4,7.6,1.8,7.7c0.4,0.1,0.8-0.1,0.9-0.6c0.5-2,1.9-3.6,3.8-4.3C8,2.3,9.6,2.4,11.1,3.1 c1.5,0.7,2.6,1.9,3.1,3.4c0.8,2.3,0.2,4.9-1.6,6.5l0.2-1.3c0-0.4-0.2-0.8-0.7-0.8c-0.4,0-0.8,0.2-0.8,0.7l-0.4,3.3 c0,0.2,0,0.4,0.2,0.6c0.1,0.2,0.3,0.3,0.5,0.3l3.4,0.4c0,0,0.1,0,0.1,0c0.4,0,0.7-0.3,0.7-0.7C15.8,14.9,15.5,14.6,15,14.5" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </SvgIcon>
        );
    }
}
